export default "__VITE_ASSET__DZK0zS3Q__"